import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

import { Typography, Tooltip } from "@aviary";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./DesignationTooltip.styles";

const DesignationTooltip = ({ ...props }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      tooltipContent={
        <Typography isMarginless type="footnote">
          {t(l.common.WeRequireType)}
        </Typography>
      }
      css={styles.iconWrapper}
      {...props}
    >
      <FontAwesomeIcon icon={faInfoCircle} size="1x" />
    </Tooltip>
  );
};

export { DesignationTooltip };
